import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  standalone: false,
  name: 'slice',
})
export class SlicePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return Array.isArray(value)
      ? value.slice(args[0] || 0, args[1] || value.length)
      : value
  }
}
